module.exports = __webpack_public_path__ + "static/img/wx.9315894.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/index/images/wx.jpg
// module id = 9CTK
// module chunks = 1